module.exports = __webpack_public_path__ + "img/voucher-about-popup.a70686c0.png";